/**
 * ErrorState Component
 * Display error messages with consistent styling
 */

import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useAppTranslation } from '@/contexts/TranslationContext';

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  const { t } = useAppTranslation();
  const displayTitle = title || t('ui.error', 'Error');

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
        <AlertCircle className="w-8 h-8 text-red-600" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{displayTitle}</h3>
      <p className="text-gray-600 mb-4 max-w-md">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          {t('ui.tryAgain', 'Try Again')}
        </button>
      )}
    </div>
  );
}
